<template>
  <b-navbar toggleable="lg" type="dark" class="header_nav">
    <b-navbar-brand href="/user"><img src="/static/str_logo.png" class="nav_logo"></b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <!-- <b-navbar-nav>
        <b-nav-item href="#">Link</b-nav-item>
        <b-nav-item href="#" disabled>Disabled</b-nav-item>
      </b-navbar-nav> -->

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right>
          <!-- Using 'button-content' slot -->
          <template v-slot:button-content>
            <em v-if="login">{{user.username}}</em>
            <em v-else>User</em>
          </template>
          <b-dropdown-item href="/auth/login" v-if="! login">ログイン</b-dropdown-item>
          <b-dropdown-item href="/auth/register" v-if="! login">新規登録</b-dropdown-item>
          <b-dropdown-item href="/auth/logout" v-if="login">ログアウト</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  name: 'NavigationBar',
  data () {
    return {
      login: false,
      user: {}
    }
  },
  created () {
    if (localStorage.getItem('auth_information')) {
      if (JSON.parse(localStorage.getItem('auth_information')).access_token) {
        this.login = true
        const $token = JSON.parse(localStorage.getItem('auth_information')).access_token
        const headers = new Headers()
        headers.append('Content-Type', 'application/json')
        headers.append('Authorization', 'Bearer ' + $token)
        // APIにPOSTリクエストを送る
        fetch(this.API_BASE_URL + '/user/info', {
          headers: headers,
          method: 'GET'
        })
          .then((response) => {
            if (response.status === 200) {
              return response.json().then((json) => {
                this.user = json
              })
            }
          })
      }
    }
  }
}
</script>

<style>
.header_nav {
  background-color: #C7381E;
}

.nav_logo {
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/NavigationBar.vue